import {
  Box,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react"
import VoiceSearch from "@components/Search/VoiceSearch"
import { ChangeEvent, useEffect, useState } from "react"
import { MdClear } from "react-icons/md"
import { useSearchBox } from "react-instantsearch-core"

function SearchBar() {
  const { query, refine, clear } = useSearchBox()

  const [searchQuery, setSearchQuery] = useState<string>(query)
  const [enableVoice, setEnableVoice] = useState<boolean>(false)

  // enable voice search on page load as it requires web APIs
  useEffect(() => {
    typeof window !== "undefined" && setEnableVoice(true)
  }, [])

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    refine(event.target.value)
    setSearchQuery(event.target.value)
  }

  const clearSearch = () => {
    clear()
    setSearchQuery("")
  }

  return (
    <Box w={"full"}>
      <InputGroup size={"md"}>
        <Input
          py={5}
          onInput={handleChange}
          placeholder={"Search"}
          value={searchQuery}
          enterKeyHint={"search"}
          onKeyUp={(event) => {
            if (event.key === "Enter") {
              event.preventDefault()
              event.currentTarget.blur()
            }
          }}
          autoFocus
        />

        <InputRightElement>
          <IconButton
            aria-label={"clear search"}
            size={"md"}
            onClick={clearSearch}
            icon={<MdClear />}
            variant={"ghost"}
            display={searchQuery.length > 0 ? "flex" : "none"}
            _hover={{ bg: "transparent" }}
          />
          {enableVoice && (
            <VoiceSearch
              query={searchQuery}
              setSearchQuery={setSearchQuery}
              display={searchQuery === "" ? "flex" : "none"}
              aria-label={"voice search"}
            />
          )}
        </InputRightElement>
      </InputGroup>
    </Box>
  )
}

export default SearchBar
